module.exports = __webpack_public_path__ + "img/slide12.8d0df2e4.jpg";